import { http } from 'http';

export default {
  deletePartner: partnerId => http.delete(`/partners/${partnerId}`)
};
